import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetUserBreedersAction} from '../action';

const tableId = 'userBreeders';

function* execute({payload: {tableDataRequest, userProfileId}}: GetUserBreedersAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getUserBreedersPage,
        successAction: adminAction.getUserBreedersSuccess,
        tableId,
        pathParams: {
            userProfileId,
        },
    }));
}
/** Runs the admin saga that loads breeder memberships for the selected user. */
export function* getUserBreedersSaga(): SagaIterator {
    yield takeLatestF('admin/GET_USER_BREEDERS', execute);
}
